import React from 'react'

import { CommerceToolsApi } from '@grandvisionhq/commercetools'
import { useProductDetailContext } from '@grandvisionhq/products'

import { ReserveInStoreButton } from '../reserve-in-store-button'

export const ReserveInStoreButtonRestContainer = () => {
  const { activeSku, productType } = useProductDetailContext()

  if (!CommerceToolsApi.isFrames(productType)) return null

  return <ReserveInStoreButton sku={activeSku} />
}
